import React, { FC, PropsWithChildren } from 'react';
import { FileVariantsEnum, UserDto } from '@sweatpals/shared';
import { Box, SxProps, Theme } from '@mui/material';
import { useMediaQuery } from '@mui/system';
import { SystemHeader } from './system-header';
import { MobileSystemFooter } from './mobile-system-footer';
import { Showable } from '../utils';
import { clsx } from '../../utils';

export interface GeneralLayoutProps extends PropsWithChildren {
	currentUser?: UserDto | null;
	isLoading?: boolean;
	isLoginPage?: boolean;
	isPurchasesPage?: boolean;
	isEventSearchPage?: boolean;
	sx?: SxProps<Theme>;
	contentSx?: SxProps<Theme>;
	headerSx?: SxProps<Theme>;
	mobileFooterSx?: SxProps<Theme>;

	getPublicFileUrl(fileId: string, variant?: FileVariantsEnum): string;
	openPurchasesPage?(): void;
	openCreateEventPage?(): void;
	openEventSearchPage?(search?: string): void;
	openDashboardPage?(): void;
	openCreateCommunityPage?(): void;
	openDownloadAppPage?(): void;
	openLoginPage?(): void;
	handleLogout?(): void;
	openBookDemoPage?(): void;
}

export const GeneralLayout: FC<GeneralLayoutProps> = props => {
	const {
		currentUser,
		isLoading,
		isLoginPage,
		isPurchasesPage,
		isEventSearchPage,
		sx,
		contentSx,
		headerSx,
		mobileFooterSx,
		children,
		openCreateCommunityPage,
		openEventSearchPage,
		openDashboardPage,
		openDownloadAppPage,
		handleLogout,
		openLoginPage,
		openPurchasesPage,
		openCreateEventPage,
		getPublicFileUrl,
		openBookDemoPage,
	} = props;
	const isLessThanSm = useMediaQuery('(max-width: 600px)');

	return (
		<Box
			sx={clsx(
				{
					height: '100%',
					overflow: 'auto',
					position: 'relative',

					'&::-webkit-scrollbar': {
						width: { xs: 0, ms: '5px' },
					},
				},
				sx,
			)}
		>
			<Showable hide={isLessThanSm}>
				<SystemHeader
					currentUser={currentUser}
					isLoading={isLoading}
					sx={headerSx}
					handleLogout={handleLogout}
					getPublicFileUrl={getPublicFileUrl}
					isPurchasesPage={isPurchasesPage}
					openDownloadAppPage={openDownloadAppPage}
					openCreateEventPage={openCreateEventPage}
					openDashboardPage={openDashboardPage}
					openPurchasesPage={openPurchasesPage}
					openLoginPage={openLoginPage}
					openEventSearchPage={openEventSearchPage}
					openCreateCommunityPage={openCreateCommunityPage}
					openBookDemoPage={openBookDemoPage}
				/>
			</Showable>
			<Box
				sx={clsx(
					{
						minHeight: {
							xs: `calc(100% - 56px)`,
							sm: `calc(100% - 66px)`,
						},
						position: 'relative',
					},
					contentSx
				)}
			>
				{children}
			</Box>
			<Showable show={isLessThanSm}>
				<MobileSystemFooter
					currentUser={currentUser}
					isLoginPage={isLoginPage}
					isPurchasesPage={isPurchasesPage}
					isEventSearchPage={isEventSearchPage}
					isLoading={isLoading}
					sx={mobileFooterSx}
					getPublicFileUrl={getPublicFileUrl}
					openCreateEventPage={openCreateEventPage}
					openEventSearchPage={openEventSearchPage}
					openDownloadAppPage={openDownloadAppPage}
					handleLogout={handleLogout}
					openLoginPage={openLoginPage}
					openDashboardPage={openDashboardPage}
					openPurchasesPage={openPurchasesPage}
					openCreateCommunityPage={openCreateCommunityPage}
					openBookDemoPage={openBookDemoPage}
				/>
			</Showable>
		</Box>
	);
};
